import React from "react";
import { Link } from "react-router-dom";

export const Card = ({
  title,
  desc,
  image,
  variant = "purple",
  icon,
  // Botón 1
  buttonText,

  // Botón 2
  buttonText2,
  buttonLink2,
}) => {
  return (
    <div className="col-lg-6">
      <div className={`feature-card feature-${variant}`}>
        <div className="feature-image">
          <img src={image} alt={title} />

          {/* ICONO FLOTANTE */}
          {icon && (
            <div className="feature-icon">
              <img src={icon} alt={title} />
            </div>
          )}
        </div>

        <div className="feature-content">
          <h3 className="titulo">{title}</h3>

          <p className="parrafo-grande" style={{textAlign: "justify"}}>{desc}</p>

          <div className="d-flex justify-content-center gap-3 flex-wrap">
            {buttonText && (
              <Link to="/bootcamp" className="btn btn-modern-purple">
                {buttonText}
              </Link>
            )}

            {buttonText2 && (
              <button
                className="btn btn-outline-primary "
                style={{
                            background:"#white",
      }}
                disabled={buttonText2 === "EN PROCESO"}
              >
                {buttonText2}
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
